import { render, staticRenderFns } from "./SelectBuildingRoomSource.vue?vue&type=template&id=ba485dde&scoped=true&"
import script from "./SelectBuildingRoomSource.vue?vue&type=script&lang=js&"
export * from "./SelectBuildingRoomSource.vue?vue&type=script&lang=js&"
import style0 from "./SelectBuildingRoomSource.vue?vue&type=style&index=0&id=ba485dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba485dde",
  null
  
)

export default component.exports